import { CommerceService } from "@/services/commerce"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getCustomer } from "../../shared/utils/getCustomer"

export const mutationAddLineItems = {
  async addLineItems(parent, args, context, info) {
    let { cartId, cartKey, storeKey, items = [] } = args

    const commerceApi = CommerceService.api()
    const action = "addLineItem"

    if (!cartId && !cartKey) return null
    const isKey = typeof cartKey === "string"

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CARTS,
      operation: Operations.UPDATE,
    })

    const currentCart = isKey
      ? (await commerceApi.carts().withKey({ key: cartKey }).get().execute()).body
      : (await commerceApi.carts().withId({ ID: cartId }).get().execute()).body

    const customer = await getCustomer({ id: currentCart.customerId })

    if (!customer) return null

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    const cartStoreKey = currentCart.store.key

    const cartStore =
      typeof cartStoreKey === "string"
        ? (await commerceApi.stores().withKey({ key: cartStoreKey }).get().execute()).body
        : null

    const distributionChannels = cartStore.distributionChannels

    const distributionChannelKeys = distributionChannels.map((channel) => {
      return channel.id
    })

    // TODO: optimize me
    const actions = await Promise.all(
      items.map(async (item) => {
        const pricesBasedOnDistributionChannelKeys = await Promise.all(
          distributionChannelKeys.map(async (key) => {
            try {
              const priceRequest = await commerceApi
                .standalonePrices()
                .get({
                  queryArgs: {
                    where: `sku="${item.sku}" and channel(id="${key}")`,
                  },
                })
                .execute()

              if (priceRequest?.body?.results.length > 0) {
                const prices = priceRequest.body.results
                // in case of multiple prices
                const minPrice = Math.min(...prices.map((itemPrice) => itemPrice?.value.centAmount))

                return { key, price: minPrice }
              }

              return null
            } catch (err) {
              console.warn(err)
              return null
            }
          }),
        )

        let channelWithLowestPrice
        if (pricesBasedOnDistributionChannelKeys.length > 0) {
          const filteredPricesDistributionChannels = pricesBasedOnDistributionChannelKeys.filter((n) => n)

          channelWithLowestPrice = filteredPricesDistributionChannels.reduce((prev, curr) => {
            return prev.price < curr.price
          })
        }

        return {
          ...item,
          action,
          ...(channelWithLowestPrice && {
            distributionChannel: {
              id: channelWithLowestPrice.key,
              typeId: "channel",
            },
          }),
        }
      }),
    )

    const payload = {
      version: currentCart.version,
      actions,
      ...(storeKey && { storeKey }),
    }

    const result = isKey
      ? await commerceApi
          .carts()
          .withKey({ key: cartKey })
          .post({
            body: JSON.stringify(payload),
          })
          .execute()
      : await commerceApi
          .carts()
          .withId({ ID: cartId })
          .post({
            body: JSON.stringify(payload),
          })
          .execute()

    const updatedCart = result.body

    return updatedCart
  },
}
